import(/* webpackMode: "eager" */ "/app/.yarn/__virtual__/next-virtual-e29b8b924f/0/cache/next-npm-14.2.25-cd023f1b24-fa0cd12ba7.zip/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["UserInquiryButton"] */ "/app/webapp/app/pwa/(main-layout)/team/[teamId]/(simple-layout)/player/[playerId]/components/UserInquiryButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/(main-layout)/team/[teamId]/(simple-layout)/widgets/components/ScrollHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/components/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/components/layout/NavBackButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/webapp/app/pwa/components/layout/NavMainLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/webapp/app/pwa/components/layout/NavSecondaryLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavToggle"] */ "/app/webapp/app/pwa/components/layout/NavToggle.tsx");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/branding/logo.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/bar-chart-horizontal.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/bar-chart.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/calendar.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/default_team_logo.png");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/grid.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/news.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/push.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/team.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/tippspiel.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/user-check.svg");
;
import(/* webpackMode: "eager" */ "/app/webapp/assets/icon/users.svg");
